export default __webpack_public_path__ + "static/media/camera.699d2306.svg";